module.exports = __webpack_public_path__ + "static/TT-Plans-Location-d4985a713a2434c59d34c628b38eace4.pdf";